export type ConnectivityCallback = (online: boolean) => void;

/** Subscribe to browser online/offline. Returns unsubscribe. */
export function subscribeConnectivity(callback: ConnectivityCallback): () => void {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const onOnline = () => callback(true);
  const onOffline = () => callback(false);

  window.addEventListener('online', onOnline);
  window.addEventListener('offline', onOffline);

  return () => {
    window.removeEventListener('online', onOnline);
    window.removeEventListener('offline', onOffline);
  };
}
